const eg = 'e.g '
export const placeholder = {
  text:eg +'Abc',
  number:eg +'123',
  link:eg + 'https://example.com',
  email:eg + 'sample@example.com',
  phonenumber:eg + '000-000-000',
  userSearch:'Search Table'
};
